export function displayValue(value: any, rut?: string, defaultText = 'No asignada') {
  // Lista de RUTs para los cuales no queremos mostrar el texto por defecto
  const suppressRuts = ['10978973-9', '12036820-6'];

  // Si el valor es exactamente null, mostrar guion visual
  if (value === null) return '-';

  if (rut && suppressRuts.includes(rut)) {
    // Para usuarios especiales devolver valor o cadena vacía (no mostrar texto por defecto)
    return value ?? '';
  }

  // Si es undefined o cadena vacía, usar el texto por defecto
  if (value === undefined || value === '') return defaultText;
  return value;
}
